<template>
  <div style="background-color: #F1F2F5;padding: 20px">
    <!-- 条件区域 -->
    <div style="background-color: #FFFFFF;padding: 20px">
      <div class="search-container">
        <input
          v-model="query.miniseries_name"
          type="text"
          placeholder="搜索产品名/短剧名/公司名/文案"
          class="search-input"
        >
        <button
          class="search-button"
          @click="materialListr"
        >
          <i class="el-icon-search" />
        </button>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div style="display: grid; grid-template-columns: repeat(auto-fill, 224px); justify-content: space-between; gap: 16px;background-color: #FFFFFF; margin-top: 20px; padding: 20px;">
      <div v-for="(item,index) in material_data.list" :key="index" style="width: 224px; height: 306px; border: 1px solid #E5E6EB;border-radius: 6px;cursor: pointer;" @click="handleInfo(item)">
        <div style="width: 222px;height: 226px;background-color: #F7F8FA;display: flex;justify-content: center;border-radius: 6px">
          <el-image
            style="width: 158px;height: 226px"
            src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline" />
            </div>
          </el-image>
        </div>
        <div style="margin-left: 20px; display: flex; flex-direction: column; justify-content: space-around; height: 80px;">
          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            {{ item.miniseries_name }}
          </div>
          <div>{{ item.created_at }}</div>
        </div>
      </div>
    </div>
    <pagination-right
      :total="material_data.total"
      :page-sizes="[30]"
      :current-page="query.page"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { materialList } from '@/api/report/dxj'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        miniseries_name: null,
        page: 1,
        page_size: 30
      },
      material_data: {
        total: 0,
        list: []
      },
      selectedValue: '',
      material_type: '',
      totalItems: [],
      slot_option: [
        { label: '最多评论数', value: '1' },
        { label: '最大时长', value: '2' },
        { label: '最大曝光量', value: '3' },
        { label: '最多分享数', value: '4' },
        { label: '最多点赞数', value: '5' },
        { label: '最多播放量', value: '6' }
      ],
      options2: [
        { label: '信息流广告', ad_value: 'info_flow' },
        { label: '原生广告', ad_value: 'native' },
        { label: '非原生广告', ad_value: 'not_native' },
        { label: '达人广告', ad_value: 'talent' }
      ],
      slot_value: null
    }
  },
  created() {
    this.materialList()
  },
  methods: {
    materialList() {
      const params = {
        ...this.query
      }
      materialList(params).then(res => {
        this.material_data = res.data
      })
    },
    fetchPageSize(data) {
      this.query.page = 1
      this.query.page_size = data
      this.materialList()
    },
    fetchCurrentPage(data) {
      this.query.page = data
      this.materialList()
    },
    handleInfo(val) {
      console.log(val)
      this.$router.push({
        name: 'dxjMaterialInfo',
        query: val
      })
    },
    materialListr() {
      this.query.page = 1
      this.materialList()
    }
  }
}
</script>

<style lang="less" scoped>
.search-container {
  display: flex;
  width: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.search-input {
  flex: 1;
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
}

.search-button {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.search-button:hover {
  background-color: #46a6ff;
}

.data-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 8px; /* 控制上下间距，不需要左右 padding */
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px; /* 你可以根据字体大小微调 */
  flex-shrink: 0;
}

.value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.label {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.divider {
  width: 1px;
  height: 30px;
  background-color: #eee;
  flex-shrink: 0;
}
</style>
